export default "__VITE_ASSET__CLcbtkU0__"